import React from 'react';
import { cn } from '../lib/utils';

// Themed accent — matches the Pages stepper's Next/Submit (see @eaco/forms-core
// theme). Falls back to the default tint outside a FormThemeProvider.
const TINT = 'var(--forms-accent,var(--forms-accent-default))';

/**
 * Shared visual for the fill action bar so the paged stepper footer and the
 * single-section fixed footer are identical (border, background, padding,
 * layout). Positioning (sticky vs. flex-none) is left to each host.
 */
export const FILL_ACTION_BAR_CLASS =
  'flex items-center gap-[10px] border-t border-[#edf0f4] bg-white px-[14px] py-[11px]';

/**
 * The narrow (phone) action bar: the same bar, full width, padded past the
 * home indicator, and marked so popovers inside the scroller can measure
 * what it covers. Compose it AFTER FILL_ACTION_BAR_CLASS: tailwind-merge
 * keeps the later padding, and this one must win.
 */
export const FILL_ACTION_BAR_NARROW_CLASS =
  'fill-bar-narrow sticky bottom-0 z-[5] flex-wrap pb-[calc(11px+env(safe-area-inset-bottom))]';
export const FILL_ACTION_BAR_ATTR = { 'data-fill-action-bar': '' } as const;

/**
 * The accent Submit button shared by the Pages stepper footer (paged forms)
 * and the fill dialog's fixed footer (single-section forms), so both submit
 * affordances are visually and behaviourally identical.
 */
export const FillSubmitButton: React.FC<{
  onClick: () => void;
  submitting?: boolean;
  disabled?: boolean;
  label?: string;
  className?: string;
}> = ({ onClick, submitting, disabled, label, className }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || submitting}
    className={cn(
      'inline-flex items-center justify-center gap-[7px] overflow-hidden rounded-[9px] px-[14px] py-[9px] text-[12.5px] font-bold text-white shadow-[0_2px_6px_rgba(47,111,219,.3)] disabled:opacity-60',
      className,
    )}
    style={{ backgroundColor: TINT }}
  >
    <span className="truncate">
      {submitting ? 'Submitting…' : label || 'Submit'}
    </span>
  </button>
);
